import { Injectable } from '@angular/core';
import { Config } from '@config';
import { AuthHttp } from '@http';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class WebAccessService {
    constructor(
        private config: Config,
        private http: AuthHttp
    ) {
    }

    public async touchProxySession(): Promise<string> {
        return await lastValueFrom(this.http.put(this.config.services.webAccess.touchProxySession, null));
    }
}
